import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BillingMonthlyBillingActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/MonthlyBilling/MonthlyBillingBrowser")
	}

	render() {
		return (
			<Activity 
				name="BillingMonthlyBilling"
				RenderedComponent={this.RenderedComponent}
				context="BillingMonthlyBilling"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BillingMonthlyBillingActivity)
